/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import * as microsoftTeams from '@microsoft/teams-js';
import PropTypes from 'prop-types';
import { ReactComponent as Woman } from 'assets/images/woman-with-clipboard.svg';
import { ReactComponent as Woman1 } from 'assets/images/women-with-dashboard.svg';
import Button from 'components/Button';
import classNames from 'classnames';
import styles from './Footer.module.scss';

const Footer = (props) => {
  const { darkTheme, freeTrial } = props;
  return (
    <div className={classNames(styles.bodyWrapper, { [styles.darkTheme]: darkTheme })}>
      {freeTrial ? <Woman /> : <Woman1 />}
      <div className={styles.detailsText}>
        <div className={darkTheme ? styles.lightText : styles.helpText}>
          <div className={styles.img}>
            {freeTrial ? 'Need help?' : 'Want to see how your team is doing?'}
          </div>
        </div>
        {!freeTrial && (
          <div className={darkTheme ? styles.lightVisitDashboardText : styles.visitDashboardText}>
            {`Visit Trivia's Dashboard to manage Billing and Licenses, view`}
            <br />
            Team Analytics, Leaderboard and much more!
          </div>
        )}
        <Button
          className={styles.demoButton}
          onClick={() => {
            const url = freeTrial
              ? 'https://api-trivia-teams.trytrivia.co/demo/'
              : process.env.REACT_APP_DASHBOARD_URL;

            // Create and trigger a real <a> element
            const anchor = document.createElement('a');
            anchor.href = url;
            anchor.target = '_blank';
            anchor.rel = 'noopener noreferrer';
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
          }}
        >
          {freeTrial ? 'Book a demo' : 'View Dashboard'}
        </Button>

        {(
          <>
            <div className={styles.orText}>OR</div>
            <span className={darkTheme ? styles.lightMailText : styles.mailText}>
              Got feedback or complaint? Reach us at{' '}
              <a
                href="mailto:support@heronhr.co"
                target="_blank"
                rel="noopener noreferrer"
              >
                support@heronhr.co
              </a>
            </span>
          </>

        )}
      </div>
    </div>
  );
};

Footer.propTypes = {
  darkTheme: PropTypes.bool,
  freeTrial: PropTypes.bool.isRequired
};

Footer.defaultProps = {
  darkTheme: false
};

export default Footer;
